var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRemoveDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFEAED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2872_216049)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5886 10.4108C21.914 10.7363 21.914 11.2639 21.5886 11.5893L11.5886 21.5893C11.2632 21.9148 10.7355 21.9148 10.4101 21.5893C10.0847 21.2639 10.0847 20.7363 10.4101 20.4108L20.4101 10.4108C20.7355 10.0854 21.2632 10.0854 21.5886 10.4108Z",
    fill: "#FF3251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4101 10.4108C10.7355 10.0854 11.2632 10.0854 11.5886 10.4108L21.5886 20.4108C21.914 20.7363 21.914 21.2639 21.5886 21.5893C21.2632 21.9148 20.7355 21.9148 20.4101 21.5893L10.4101 11.5893C10.0847 11.2639 10.0847 10.7363 10.4101 10.4108Z",
    fill: "#FF3251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2872_216049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveDanger);
export default __webpack_public_path__ + "static/media/icon_remove_danger.05144bde08a0a9caf2eea8886ab2e987.svg";
export { ForwardRef as ReactComponent };